import React, { useState, useRef } from "react";
import { routes } from "./route";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { IMG, LOGO } from "../../../assets";
import { motion } from "framer-motion";
import ARROW from "../../../assets/downarrow.png";
import "./Header.css";

export default function SecondaryHeader({ isHeaderFixed, id }) {
  const [showTreatments, setShowTreatments] = useState(false);
  // const treatmentsRef = useRef(null);
  const headerRef = useRef(null);
  const timeoutRef = useRef(null);

  const handleScrollToSection = (hash) => {
    setShowTreatments(false);
    setTimeout(() => {
      const element = document.getElementById(hash.substring(1));
      const headerHeight = headerRef.current.offsetHeight;

      if (element) {
        const offsetTop = element.offsetTop - headerHeight;
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
        window.history.pushState(null, null, hash);
      }
    }, 300);
  };
  // Handles the mouse enter with immediate display of dropdown
  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current); // Clear the timeout to prevent closing
    setShowTreatments(true);
  };

  // Handles the mouse leave with a delay before hiding dropdown
  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowTreatments(false);
    }, 200); // Delay before closing the dropdown
  };

  const textHoverVariants = {
    hover: { scale: 1.1, color: "#B1F4F4" }, // Scale up and change text color
  };

  const social = [
    { id: 1, name: "linkedin", icon: IMG.INB },
    { id: 2, name: "twitter", icon: IMG.TWB },
    { id: 3, name: "youtube", icon: IMG.YTB },
    { id: 4, name: "facebook", icon: IMG.FBB },
    { id: 5, name: "instagram", icon: IMG.INSH },
  ];

  console.log("isHeaderFixed in sec", isHeaderFixed);
  console.log("id={id}", id);

  return (
    <div ref={headerRef}>
      <ul className="bg-[#35373A] relative lg:flex hidden justify-center items-center px-5 font-poppins tracking-wider">
        <div className="w-full flex justify-between items-center max-w-screen-2xl py-10">
          <div className="h-full left-0 flex justify-center items-center gap-5 ">
            <Link
              to="/"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
            >
              <img src={LOGO.LOGO} alt="logo" className="h-[50px] mr-6" />
            </Link>
            <div className="flex gap-8 relative z-20 items-center">
              {routes.map((route) => {
                const { href, title, hash } = route;
                return (
                  <li key={title} className="relative tracking-widest">
                    {hash ? (
                      <span
                        onClick={() => handleScrollToSection(hash)}
                        className="flex items-center gap-1 hover:text-neutral-400 transition-all text-white text-base font-thin cursor-pointer"
                      >
                        {title}
                      </span>
                    ) : (
                      <Link
                        to={href}
                        className="flex items-center hover:text-neutral-400 transition-all hover:text-primary text-white font-light"
                        onClick={() => {
                          if (title === "Contact Us") {
                            handleScrollToSection("#contact");
                          }
                        }}
                        onMouseEnter={() =>
                          title === "Treatments" && handleMouseEnter()
                        }
                        onMouseLeave={() =>
                          title === "Treatments" && handleMouseLeave()
                        }
                      >
                        {title}
                        {title === "Treatments" && (
                          <img
                            src={ARROW}
                            alt="Treatments"
                            className="w-[15%]"
                          />
                        )}
                        {title === "Treatments" && showTreatments && (
                          <div className="relative ">
                            <div className="absolute top-[60px] -left-[54px] transform translate-x-1/2">
                              <div className="w-0 h-0 border-l-[20px] border-l-transparent border-r-[20px] border-r-transparent border-b-[20px] border-b-secondary rotate-180"></div>
                            </div>

                            {/* <div className="bg-secondary text-white rounded-lg shadow-xl absolute top-[34px] -left-[125px] mt-8 w-[534px]"> */}
                            <div
                              className={`bg-secondary text-white rounded-lg shadow-xl absolute ${
                                (isHeaderFixed && id === "insurance") || !id
                                  ? "top-[34px]"
                                  : "-top-[8px]"
                              } -left-[125px] mt-8 w-[534px]`}
                            >
                              <div className="flex items-center justify-center  gap-2 pr-[1%] pl-[1.5%] font-poppins">
                                <HashLink to="/treatment#Pedodontists">
                                  <motion.div
                                    whileHover="hover"
                                    variants={textHoverVariants}
                                    className="py-[18%] text-[14px] font-light tracking-tigh  "
                                  >
                                    Pedodontists
                                  </motion.div>
                                </HashLink>
                                <hr className="border-r-[1px] pt-6 border-[#E2E2E2]" />
                                <HashLink to="/treatment#Orthodontists">
                                  <motion.div
                                    whileHover="hover"
                                    variants={textHoverVariants}
                                    className="py-[18%] text-[14px] font-light tracking-tigh  "
                                  >
                                    Orthodontists
                                  </motion.div>
                                </HashLink>
                                <hr className="border-r-[1px] pt-6 border-[#E2E2E2]" />
                                <HashLink to="/treatment#Periodontists">
                                  <motion.div
                                    whileHover="hover"
                                    variants={textHoverVariants}
                                    className="py-[18%] text-[14px] font-light tracking-tigh  "
                                  >
                                    Periodontists
                                  </motion.div>
                                </HashLink>
                                <hr className="border-r-[1px] pt-6 border-[#E2E2E2]" />
                                <HashLink to="/treatment#Endodontists">
                                  <motion.div
                                    whileHover="hover"
                                    variants={textHoverVariants}
                                    className="py-[18%] text-[14px] font-light tracking-tigh  "
                                  >
                                    Endodontists
                                  </motion.div>
                                </HashLink>
                              </div>
                            </div>
                          </div>
                        )}
                      </Link>
                    )}
                  </li>
                );
              })}
              {/* <button className="bg-primary glow-on-hover button px-8 py-2 text-secondry font-bold rounded-full ml-20">
              CONTACT
            </button> */}
            </div>
          </div>
          <div
            // initial="hidden"
            // animate={isVisible ? "visible" : "hidden"}
            // variants={textAnimation}
            // transition={{ duration: 0.8 }}
            // ref={ref}
            className="flex justify-end items-center gap-11 "
          >
            {social.map((data) => (
              <img
                key={data.id}
                src={data.icon}
                alt={data.name}
                className="h-6 cursor-pointer"
              />
            ))}
          </div>
        </div>
      </ul>
    </div>
  );
}
